export default {
    "label.update_translations_unsuccessful": "Št. neuspešno posodobljenih: {count}",
    "global.no_records": "Ni zapisov",
    "notifications.rp_has_been_updated": "PNP je posodobljen.",
    "moduleTitle.files": "Datoteke",
    "label.coordinator": "Koordinator",
    "sidebar.translations_managment": "Upravljanje prevodov",
    "table.file": "Datoteka",
    "label.report_overview": "Pregled",
    "label.parent_agreement": "Soglasje starša/skrbnika",
    "parentalConsent.i_consent_to_and_understand_that": "6. Soglašam in razumem, da se sme fotografirati udeležence, ki sodelujejo v določenih dejavnostih, povezanih s programom MEPI, te fotografije pa se lahko uporabi v promocijske namene, če sta tako udeleženec/-ka kot njegov/njen starš/skrbnik podpisala ustrezen obrazec.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Razumem, da se morajo udeleženci držati zahtev programa MEPI, opisanih v indeksu dosežkov ali ORB-ju, pravilnikov in standardov vedenja pristojne izvajalske organizacije (kot se sproti dopolnjujejo) in zahtev izvajalske organizacije v povezavi z načrti za izredne razmere, ocenjevanjem dejavnosti in vodenjem pustolovskih odprav, povezanih s programom; obenem razumem, da lahko izvajalska organizacija umakne odobritev sodelovanja udeleženca/-ke v programu, če se ta tega ne drži.",
    "table.end_date": "Datum zaključka",
    "label.activation_date": "Datum aktivacije",
    "label.report": "Poročilo",
    "label.award_is_offline": "Tiskan indeks",
    "label.pending_changes": "Spremembe še niso shranjene ...",
    "errors.min_nights_required": "Najmanjše število noči: {nights}",
    "label.country": "Država",
    "notifications.award_leader_has_been_returned": "Mentor je zavrnjen",
    "notifications.participant_has_been_updated": "Udeleženec je posodobljen.",
    "label.phone_number": "Telefonska številka",
    "roles.aj_assessor": "Ocenjevalec pustolovske odprave",
    "notifications.person_state_has_been_changed": "Stanje osebe je bilo spremenjeno.",
    "pageTitle.dashboard": "Začetna stran",
    "moduleTitle.global_payment_method": "Nastavitve plačil",
    "label.organization_type": "Vrsta organizacije",
    "button.account_settings": "Nastavitve",
    "notifications.contact_has_been_updated": "Kontakt je posodobljen.",
    "participant.recover_password": "Ponastavi geslo",
    "notifications.assessment_request_has_been_sent": "Zahteva za ocenjevanje je bila poslana",
    "button.unassign": "Odstrani",
    "label.start_date": "Datum začetka",
    "label.assign_labels": "Dodeli oznake",
    "sidebar.participants": "Udeleženci",
    "roles.coordinator": "Koordinator",
    "label.organization_contact": "Kontakt organizacije",
    "tabs.customization": "Napredne možnosti",
    "sidebar.award_units": "Izvajalske organizacije",
    "button.change_goal": "Spremeni cilj",
    "translationsManagement.selectProject": "Izberi projekt",
    "award.rp": "Projekt Neznani prijatelj",
    "label.size": "Velikost",
    "label.bulk_action_results": "Rezultati spremembe ",
    "notifications.activity_has_been_approved": "Dejavnost je odobrena",
    "label.payment_type": "Vrsta plačila",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Ponovno pošlji zahtevo za ocenjevanje",
    "notifications.template_has_been_removed": "Predloga je bila odstranjena.",
    "button.award_settings": "Nastavitve stopnje",
    "pageTitle.payment": "Plačilo",
    "tasks.return_award": "Vrni priznanje v dopolnitev",
    "label.link": "povezava",
    "moduleTitle.award_participant_delete": "Izbriši stopnjo",
    "pageTitle.mro_related_contacts": "Regionalna pisarna IAF - povezane osebe",
    "pageTitle.my_organization_labels": "Moja organizacija - Oznake",
    "tabs.activity_signoff": "Potrditev področja",
    "table.logs": "Dnevniki",
    "moduleTitle.remove_file": "Ali želite odstraniti datoteko?",
    "label.email_confirmed": "E-naslov potrjen",
    "notifications.activity_has_been_returned": "Dejavnost vrnjena v dopolnitev",
    "label.note": "Opomba",
    "button.show": "Pokaži",
    "tabs.adventurous_journey": "Pustolovska odprava",
    "sidebar.my_todolist": "Moja opravila",
    "label.here": "tukaj",
    "organisation.change_award_mode": "Spremeni način beleženja Programa MEPI",
    "table.note_from_al": "Opomba mentorja",
    "label.gender": "Spol",
    "moduleTitle.remove": "Ali želite odstraniti element?",
    "errors.must_be_less_than": "Mora biti manj kot {limit}",
    "button.logout": "Odjava",
    "label.no_selected_participants": "Ni izbranih udeležencev",
    "button.new_aj_event": "Nova pustolovska odprava",
    "label.employement_status": "Status zaposlitve",
    "tabs.logs": "Dnevniki",
    "tabs.contacts": "Kontakti",
    "label.option": "Možnost",
    "dashboard.charts": "Grafikoni",
    "notifications.rp_has_been_approved": "PNP je odobren.",
    "pageTitle.new_participant": "Nov udeleženec",
    "notifications.award_leader_has_been_approved": "Mentor je odobren.",
    "moduleTitle.would_you_like_to_remove_leader_training": "Ali želite izbrisati to usposabljanje?",
    "moduleTitle.update_configuration_value": "Posodobi konfiguracijsko vrednost",
    "table.description": "Opis",
    "table.organization": "Organizacija",
    "label.youtube": "YouTube",
    "label.author": "Avtor",
    "table.suitable_for_award_level": "Stopnja",
    "label.content_update": "Počakaj. Vsebina se posodablja ...",
    "notifications.new_question_has_been_added": "Novo vprašanje je bilo dodano.",
    "pageTitle.nao_awards": "Nacionalni urad – priznanja",
    "table.last_name": "Priimek",
    "moduleTitle.adventurous_journey_detail": "Podatki o odpravi",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Množična dejanja"},
    "label.project_location_type": "Vrsta kraja projekta",
    "label.email_help_award_level": "Stopnja programa",
    "label.date": "Datum",
    "label.previous_completed_award_place": "Organizacija (prejšnja stopnja)",
    "button.show_more": "Pokaži več",
    "label.wwc_number": "WWC number",
    "button.filter": "Filtriraj",
    "notifications.rp_has_been_returned": "PNP je bil vrnjen v dopolnitev",
    "pageTitle.residetial_project_assessor_report": "PNP – poročilo ocenjevalca",
    "label.generating": "Pripravljam...",
    "moduleTitle.finance_system_data": "Finančni podatki",
    "notifications.adventurous_journey_state_has_been_changed": "Stanje pustolovske odprave je spremenjeno.",
    "route.levels": "Stopnje",
    "moduleTitle.activity_leader": "Področni inštruktor",
    "tasks.approve_event": "Odobri odpravo",
    "tasks.reject_event": "Vrni odpravo v dopolnitev",
    "table.region": "Statistična regija",
    "pageTitle.nao_award_leaders": "Nacionalni urad – mentorji",
    "errors.must_be_at_least": "Najmanjše število znakov: {min}",
    "table.title": "Naziv",
    "table.last_activity": "Zadnja dejavnost",
    "tasks.delete_registration": "Izbriši registracijo",
    "table.date_time": "Čas (lokalno)",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Izvajalske organizacije spoštujejo vašo zasebnost. Osebni podatki s tega obrazca so namenjeni sodelovanju v programu MEPI. Udeleženci, ki teh podatkov ne priskrbijo, ne morejo sodelovati v programu (to ne velja za podatke o udeležencu). Vaše osebne podatke bomo morda uporabili tudi, da vam pošljemo informacije o drugih dejavnostih ali dogodkih v programu, ki bi vas utegnili zanimati. Te podatke lahko delimo z drugimi lokalnimi ali mednarodnimi organizacijami ali ponudniki storitev, ki nam pomagajo v organizaciji in administraciji programa. Če nas želite kontaktirati ali dostopiti do svojih osebnih podatkov, prosimo, pišite izvajalski organizaciji. Organizacijo lahko kontaktirate tudi, če želite kopijo njene politike zasebnosti.",
    "aj.practice_journey": "Poskusna odprava",
    "notification.log_has_been_restored": "Dnevnik dejavnosti je bil obnovljen",
    "tabs.my_participants": "Moji udeleženci",
    "label.bulk_action_assign_label": "Dodeli oznako",
    "moduleTitle.supervisor": "Spremljevalec",
    "moduleTitle.your_parental_consent": "Soglasje staršev",
    "route.registration_participants": "Registracija udeležencev",
    "placeholder.start_typing": "Začni tipkati ...",
    "tasks.approve_award": "Potrdi priznanje",
    "route.registrations": "Registracije",
    "button.add_activity": "Dodaj dejavnost",
    "notifications.aj_event_has_been_created": "Pustolovska odprava je bila ustvarjena",
    "states.supervisor_approval": "Vpis ocene",
    "label.description": "Opis",
    "button.leave_anyway": "Vseeno zapusti",
    "tabs.registrations": "Registracije",
    "states.leader_signoff": "Potrditev mentorja",
    "moduleTitle.forbidden": "Ni dovoljeno",
    "notifications.translations_has_been_updated.button": "Prevodi so bili posodobljeni.",
    "pageTitle.nao_registration": "Nacionalni urad – registracija",
    "pageTitle.mro_logs": "Regionalna pisarna IAF – dnevniški vnosi",
    "meta.page_not_found": "Stran ni najdena",
    "label.bulk_action_unsuccessful": "Posodobitev za {count} elementov ni uspela.",
    "global.days": "dni",
    "table.review": "Pregled",
    "table.as_assessor_for": "Kot ocenjevalec za",
    "roles.if_staff_statistical_user": "Up. statističnih funkcij (IAF)",
    "table.levels": "Stopnje",
    "label.suitable_for_level": "Stopnja",
    "pageTitle.leaders": "Mentorji",
    "moduleTitle.send_test_email": "Pošlji preizkusno e-poštno sporočilo",
    "pageTitle.tasks_removed_registration": "Izbrisane registracije udeležencev",
    "label.you_will_be_forced_to_login_again_after_change": "Po spremembi se boste morali znova prijaviti.",
    "table.recent_updates": "Nedavne posodobitve",
    "pageTitle.tasks_activity_signoffs": "Potrditve področja",
    "pageTitle.payments": "Plačila",
    "global.nights": "noči",
    "label.blank_any_level": "BREZ MENTORJA",
    "button.view_section": "Poglej področje",
    "moduleTitle.select_organization": "Izbira organizacije",
    "pageTitle.manual_data_import": "Ročni uvoz podatkov",
    "button.upload_files": "Naloži datoteke",
    "label.migrated_contact_email": "E-naslov prenesenega kontakta",
    "label.for_award_unit": "Za izvajalsko organizacijo",
    "label.aj_template_note": "Opomba k predlogi",
    "table.last_log_added": "Zadnji vnos dodan",
    "button.view_participant": "Od udeleženca",
    "label.please_comment_on_the_participants": "Prosimo, vnesite pozitivno opisno oceno za udeleženca. Pri pisanju se osredotočite na posameznikovo predanost, vztrajnost in napredek.",
    "label.consent_already_given_login": "Soglasje je bilo že poslano.",
    "participant.level_start_date": "Datum začetka – {value}",
    "sidebar.my_region_office": "Nastavitve organizacije",
    "states.section_signoff": "Potrditev mentorja",
    "moduleTitle.assessor_details": "Podatki o ocenjevalcu",
    "moduleTitle.adventurous_journey_settings": "Nastavitve pustolovske odprave",
    "moduleTitle.note_from_al": "Opomba mentorja",
    "button.add_role": "Dodaj vlogo",
    "table.run": "Zaženi",
    "states.change_to_state_warning_missing_assessment": "OPOZORILO! Ocene niso vpisane. Res želite nadaljevati?",
    "label.user_app_guide_leader": "Priročnik za uporabnike (aplikacija - mentorji)",
    "tabs.section_approval": "Potrditev področja",
    "roles.award_verifier": "Overitelj priznanja",
    "tabs.activity_approval": "Pregled ciljev",
    "logs.add_log": "Dodaj dnevniški zapis",
    "tabs.award": "Priznanje",
    "notifications.this_role_has_read_only_persmission": "Ta vloga ima dovoljenje le za branje",
    "table.no_filtered_results": "Ni filtriranih rezultatov",
    "button.praise": "Komentar",
    "label.prevent_welcome_email_assessor": "Ne pošlji informativnega sporočila področnemu inštruktorju",
    "label.location_detail": "Podrobnosti o kraju",
    "label.optional": "(neobvezno)",
    "errors.do_not_match": "Se ne ujema",
    "label.use_comma_for_multiple_entries": "Posamezne vrednosti ločite z vejico",
    "label.operating_authority": "Regionalni urad",
    "label.activity_section": "Področje dejavnosti",
    "notifications.you_have_been_logged_out": "Odjava je uspela.",
    "table.finished": "Zaključeno",
    "button.same_as_billing": "Isti naslov kot za plačilo",
    "table.payment": "Plačilo",
    "table.current_level": "Trenutna stopnja",
    "button.view_nao": "Zavrnjeno s strani NU",
    "table.email_confirmation": "Potrditev e-naslova",
    "moduleTitle.shipping_address": "Naslov za dostavo",
    "label.secondary_phone_type": "Vrsta dodatnega telefona",
    "notifications.saved": "Shranjeno",
    "pageTitle.all_participants": "Vsi udeleženci",
    "label.first_name": "Ime",
    "label.oa_price": "Cena izvajalske organizacije",
    "table.award_mode": "Način beleženja Programa MEPI",
    "tabs.api_keys": "API ključi",
    "award.award_detail": "Pregled stopnje",
    "tabs.user_management": "Upravljanje uporabnikov",
    "tabs.all_events": "Vse odprave",
    "notifications.history_record_has_been_removed": "Vnos zgodovine je bil odstranjen.",
    "award.no_data": "Ni podatkov",
    "notifications.preparation_training_has_been_added": "Priprave na odpravo so bile dodane.",
    "label.message": "Sporočilo",
    "notifications.participant_info_updated": "Podatki o udeležencu so bili posodobljeni.",
    "roles.nao_staff": "Nacionalni urad",
    "tabs.adventurous_journeys": "Pustolovske odprave",
    "label.gops": "",
    "route.upload": "Naloži",
    "notifications.history_record_has_been_added": "Vnos zgodovine je bil dodan.",
    "notifications.history_record_has_been_updated": "Vnos zgodovine je bil posodobljen.",
    "label.no_data": "Ni podatkov",
    "button.add_coordinator": "Dodaj koordinatorja",
    "label.you_are_already_logged_as": "Prijavljen si kot ",
    "route.my_national_office": "Moj nacionalni urad",
    "tabs.leaders": "Mentorji",
    "label.email_confirmation": "Potrditev e-naslova",
    "table.registration_date": "Datum registracije",
    "notifications.role_has_been_removed": "Vloga je bila odstranjena.",
    "button.move": "Premakni",
    "label.terms_and_conditions": "Splošni pogoji",
    "pageTitle.detail": "Podrobnosti",
    "table.award_unit": "Izvajalska organizacija",
    "sidebar.settings": "Nastavitve organizacije",
    "dashboard.leader_state": "Mentorji – po državah",
    "notifications.award_unit_has_been_approved": "Izvajalska organizacija je odobrena.",
    "states.awaiting_approval": "Čakanje na odobritev",
    "table.level": "Stopnja",
    "table.action_requested": "Zahtevano dejanje",
    "label.organisation_mode": "Način beleženja",
    "label.no_note": "Ni opomb",
    "tabs.my_events": "Moje odprave",
    "notifications.participants_have_been_added": "Udeleženci so bili dodani.",
    "tabs.registration_questions": "Vprašanja ob registraciji",
    "button.delete_registration": "Izbriši registracijo",
    "notifications.parental_consent_link_has_been_sent": "Povezava do obrazca za soglasje starša je bila poslana.",
    "moduleTitle.select_role_organization": "Izberi vlogo in organizacijo:",
    "label.experience": "Izkušnje",
    "translationsManagement.modal.title": "Upravljanje prevodov",
    "table.ic": "Neodvisna država",
    "table.id": "ID",
    "label.notify_email_explanation": "Udeleženec bo obveščen, da njegove prošnje za ocenjevanje dejavnosti ni bilo mogoče dostaviti in da naj popravi e-poštni naslov ocenjevalca v ORB-ju.",
    "participant.would_you_like_to_remove": "Ali želite izbrisati ta račun?",
    "table.fields_included": "Vključeni podatki",
    "label.user_guide_web_leader": "Priročnik za uporabnike (splet - mentorji)",
    "label.journey_type": "Vrsta odprave",
    "button.setup": "Nastavi",
    "tabs.my_national_office": "Moj nacionalni urad",
    "notifications.training_has_been_removed": "Usposabljanje je bilo odstranjeno.",
    "label.nominated_and_identified_persons": "Osebe, ki lahko vidijo podatke, vendar jih ne morejo urejati",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Zaradi nedejavnosti ste bili odjavljeni",
    "states.award_leader_signoff": "Potrditev mentorja",
    "table.award_signoff_attempts": "Poskusi potrjevanja priznanja",
    "sidebar.regions": "Regije",
    "label.activity_deleted_note": "Dejavnost je izbrisana. Obnoviš jo lahko s pritiskom na spodnji gumb.",
    "table.total": "Skupaj",
    "errors.a_problem_has_occured_during_processing": "Med obdelavo je prišlo do težav, oglejte si več informacij.",
    "participant.participant_already_has_gold_award": "Udeleženec že ima zlato priznanje.",
    "pageTitle.mro": "Regionalna pisarna IAF",
    "notifications.authorization_code_has_expired": "Avtorizacijska koda je potekla",
    "moduleTitle.child_organization_labels": "Oznake izvajalskih organizacij",
    "aj.aj_events": "Odprave",
    "global.loading": "Nalaganje",
    "label.gnipp": "BDP",
    "sidebar.registrations": "Registracije",
    "label.any_string": "Katerikoli niz",
    "contact.change_contact_status": "Spremeni status kontakta",
    "tabs.registration": "Registracija",
    "label.override_payment_note": "Opombe glede plačila",
    "notifications.section_has_been_signed_off": "Področje je potrjeno.",
    "label.payment_date": "Datum plačila",
    "button.approve": "Odobri",
    "moduleTitle.loggin_in": "Prijavljanje ...",
    "label.website": "Spletna stran",
    "label.role": "Vloga",
    "table.assessor_report": "Poročilo ocenjevalca",
    "label.ue_fe": "User Engagement Frontend (Participant web static labels)\n",
    "label.please_comment_on_the_participants_effort": "Navedite podrobnosti o izkazanem trudu, napredovanju, pridobljenih izkušnjah in splošni uspešnosti udeleženca",
    "label.previously_worked_as_assessor": "Že prej opravljal naloge ocenjevalca",
    "pageTitle.registrations": "Registracije",
    "parentalConsent.this_form_must_be_completed": "Ta obrazec <strong>morajo</strong> izpolniti starši/skrbniki udeležencev,  <strong> mlajših od 18 let </strong>.",
    "button.apply": "Potrdi",
    "errors.include_at_least_one_number": "Vsebovati mora vsaj eno številko",
    "label.content_restore": "Osveževanje seje ...",
    "logs.hour": "h",
    "parentalConsent.i_have_read_and_understand": "7. Prebral/-a in razumel/-a sem različne stopnje in zahteve programa MEPI, kot so določene v orisu programa (5. str. tega obrazca).",
    "notifications.award_was_deleted": "Stopnja je izbrisana.",
    "label.journey_category": "Tip odprave",
    "notifications.search_cancelled": "Iskanje je bilo prekinjeno, počakaj, da se iskanje konča.",
    "route.detail": "Podrobnosti",
    "route.user_guide": "Uporabniški priročnik",
    "moduleTitle.history": "Zgodovina",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Udeleženci brez mentorja",
    "states.inactive": "Neaktiven",
    "pageTitle.search_results": "Rezultati iskanja",
    "button.proceed_to_login": "Nadaljuj s prijavo",
    "pageTitle.assessor_report_reject": "Preglej poročilo ocenjevalca",
    "notifications.contact_has_been_removed": "Kontakt je bil odstranjen.",
    "sidebar.operating_authorities": "Regionalni uradi",
    "label.no_note_from_participant": "Ni opombe udeleženca",
    "aj.preparation_and_training": "Priprave na odpravo",
    "route.user_guide_web_leader": "Uporabniški priročnik za mentorje - spletna platforma",
    "label.position_in_organization": "Vloga v organizaciji",
    "errors.emails_dont_match": "E-naslova se ne ujemata",
    "route.my_participants": "Moji udeleženci",
    "pageTitle.customisations": "Po meri",
    "tabs.localization_files": "Lokalizacijske datoteke",
    "table.assessor_approval": "Odobritev ocenjevalca",
    "tabs.related_contacts": "Povezane osebe",
    "table.aus": "Izvajalske organizacije",
    "table.category": "Kategorija",
    "errors.file_is_too_large": "Datoteka je prevelika.",
    "label.possible_values": "Možne vrednosti:",
    "label.if_your_download_doesnt_start": "Če se prenos ne začne samodejno, klikni tukaj:",
    "route.independent_award_centres": "IAC-ji",
    "pageTitle.user_guide": "Uporabniški priročniki",
    "button.visit": "Obišči",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Moja organizacija – podrobnosti",
    "pageTitle.nao_detail": "Nacionalni urad – podrobnosti",
    "button.change": "Spremeni",
    "award.aj": "Pustolovska odprava",
    "table.award_state": "Stanje stopnje",
    "pageTitle.tasks_award_signoff": "Potrditve priznanj",
    "pageTitle.regions": "Regije",
    "notifications.award_has_been_signed_off": "Priznanje je potrjeno.",
    "dashboard.award_approved_by": "Odobrena priznanja – po stopnjah v 2016",
    "tabs.new_template": "Nova predloga",
    "error.parent_email_must_be_filled": "E-naslov staršev je obvezen",
    "label.organisation_invoicing_name": "Naziv organizacije",
    "pageTitle.related_contacts": "Povezane osebe",
    "button.try_again": "Zapri opozorilo in poskusi znova",
    "label.cannot_be_change_to_another": "Ni mogoče spremeniti stopnje",
    "notifications.lead_coordinator_has_been_set": "Nov glavni koordinator je nastavljen",
    "label.training_name": "Naziv usposabljanja",
    "moduleTitle.new_contact": "Nov kontakt",
    "translationsManagement.modal.updateTitle": "Posodabljanje prevodov",
    "moduleTitle.offline_award_units_signoff": "Avtorizacija tiskanega indeksa",
    "notifications.award_level_has_been_changed": "Stopnja programa je bila spremenjena.",
    "label.subject": "Zadeva",
    "route.silver_level": "Srebrna stopnja",
    "label.privacy_notice": "Obvestilo o zasebnosti",
    "label.switch_organization": "Zamenjava organizacije",
    "meta.dofe_name": "Mednarodno priznanje za mlade",
    "route.profile": "Profil",
    "roles.super_user": "Up. s polnimi pooblastili",
    "dashboard.while_you_were_gone": "Med tvojo odsotnostjo",
    "label.no_note_from_award_leader": "Zavrnjeno s strani NU MEPI (brez opombe)",
    "label.middle_name": "Drugo ime",
    "moduleTitle.new_activity": "Nova dejavnost",
    "organisation.would_you_like_to_remove": "Ali želiš odstraniti to organizacijo?",
    "label.state_province": "Občina",
    "moduleTitle.your_home_address": "Domači naslov",
    "tabs.sign_offs": "Potrditve",
    "moduleTitle.logs": "Dnevniki",
    "button.view_more": "Poglej več",
    "label.profile": "Profil",
    "label.title": "Naziv",
    "tabs.award_signoff": "Potrditev priznanja",
    "label.post_code": "Poštna številka",
    "states.ceremony_certificate": "Podelitev",
    "label.code": "Koda",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Soglašam s posredovanjem osebnih podatkov, ki sem jih posredoval/-a (vključno  s podatki o udeležencu/-ki) izvajalski organizaciji. Soglašam, da se s temi podatki ravna v skladu s politiko zasebnosti pristojne izvajalske organizacije (kot se sproti dopolnjuje), državnimi načeli zasebnosti, kot so določeni v Zakonu o varstvu osebnih podatkov, in drugo zakonodajo, standardi, smernicami ali navodili, vezanimi na zasebnost v zakonodaji o varstvu osebnih podatkov.",
    "label.user_guide_web_participant": "Priročnik za uporabnike (splet - udeleženci)",
    "label.award_unit_type": "Vrsta izvajalske organizacije",
    "states.complete": "Zaključeno",
    "table.participant_state": "Stanje udeleženca",
    "pageTitle.my_organization_payment": "Moja organizacija – plačilo",
    "table.approved": "Odobreno",
    "pageTitle.my_organization_contacts": "Moja organizacija – osebe",
    "warning.award_marked_as_paid_registration": "Opozorilo! Udeleženec je že plačal pristopnino za trenutno stopnjo programa. Pred potrditvijo izbrisa se posvetujte z Nacionalnim uradom MEPI.",
    "states.change_to_state": "Premakni na korak: <strong>{state}</strong>",
    "label.integer": "Celo število",
    "notifications.translationUpdateInterrupted": "Posodobitev prekinjena",
    "notifications.password_has_been_changed": "Geslo je bilo spremenjeno.",
    "button.invite_assessor": "Povabi ocenjevalca",
    "label.other_activity": "Druga dejavnost",
    "notifications.parental_consent_has_been_sent": "Soglasje starša je bilo poslano.",
    "button.revise": "Vrni v dopolnitev",
    "errors.end_date_must_be_after_start_date": "Datum zaključka ne more biti pred datumom začetka.",
    "label.award_leader_signoff_date": "Datum potrditve mentorja",
    "parentalConsent.i_understand_every_participant_must": "8. Razumem, da mora vsak udeleženec sodelovati prek izvajalske organizacije, ki ima pravico sprejeti ali zavrniti udeleženca in predlagane dejavnosti v sklopu programa MEPI.",
    "moduleTitle.policies": "Pravilniki",
    "pageTitle.tasks_aj": "Pustolovske odprave",
    "global.day": "dan",
    "moduleTitle.coordinator": "Koordinator",
    "label.region": "Statistična regija",
    "button.add_history_record": "Dodaj vnos zgodovine",
    "moduleTitle.adventurous_journey_template_settings": "Nastavitve predloge pustolovske odprave",
    "notifications.personal_details_have_been_updated": "Osebni podatki so posodobljeni.",
    "sidebar.ics": "Neodvisne države",
    "table.independent_award_centre": "IAC",
    "label.undelivered_mail_reason": "Razlog zavrnitve e-pošte",
    "table.utc_date_time": "Čas (UTC)",
    "moduleTitle.emails": "E-naslovi",
    "label.backoffice": "Backoffice",
    "moduleTitle.parent_consent": "Soglasje starša/skrbnika",
    "label.photo_consent_given": "Udeleženec se strinja, da se lahko njegovo profilno sliko uporablja v promocijske namene.",
    "moduleTitle.authorising_contact": "Odgovorna oseba",
    "label.assessment_with_role": "Ocenjevanje: {role}",
    "dashboard.type_of_awards": "Vrsta izvajalske organizacije",
    "moduleTitle.payment": "Plačilo",
    "states.in_progress": "V teku",
    "logs.no_logs": "Ni dnevniških vnosov",
    "sidebar.my_office": "Nastavitve organizacije",
    "label.assessor_report": "Poročilo ocenjevalca",
    "notifications.rp_has_been_signed_off": "PNP je potrjen.",
    "tabs.labels": "Oznake",
    "sidebar.payments": "Plačila",
    "meta.profile_questions": "Predstavitvena vprašanja",
    "label.fax": "Faks",
    "label.email_help_custom_link": "Povezava po meri (opcijsko).",
    "label.last_name": "Priimek",
    "organisation.manage_gop": "",
    "table.parental_consent": "Soglasje staršev",
    "dashboard.participant_by_level": "Udeleženci – po stopnjah",
    "tabs.award_leaders": "Mentorji",
    "label.i_confirm_that_ive_witnessed": "Potrjujem pravilnost vnosov v dnevniku udeleženca",
    "table.lead_coordinator": "Glavni koordinator",
    "states.deleted": "Izbrisano",
    "label.no_answers": "Ni odgovorov",
    "button.add": "Dodaj",
    "label.exchequer_number": "Davčna številka",
    "label.waiting": "Čakanje",
    "label.email_help_person_full_name": "Ime in priimek.",
    "tasks.return_registration": "Vrni registracijo v dopolnitev",
    "notifications.state_aj_preparation_training_has_been_changed": "Stanje pripravljanih treningov je bilo spremenjeno.",
    "label.parent_approval": "Soglasje starša/skrbnika",
    "table.assessor_approve": "Odobritev ocenjevalca",
    "errors.some_fields_requires_your_attention": "Nekaj polj je treba pregledati.",
    "aj.qualifying_journey": "Kvalifikacijska odprava",
    "route.awards": "Avtorizacija priznanj",
    "table.registration": "Registracija",
    "pageTitle.assessors": "Ocenjevalci",
    "notifications.award_has_been_updated": "Stopnja MEPI je posodobljena.",
    "errors.must_be_one_of": "Mora biti eno od: {enums}",
    "pageTitle.logs": "Dnevnik",
    "notifications.notifications.invitation_has_been_sent": "Vabilo je bilo poslano.",
    "route.national_offices": "Nacionalni uradi",
    "notifications.training_has_been_updated": "Usposabljanje je bilo posodobljeno.",
    "label.parent_last_name": "Priimek starša/skrbnika",
    "table.leaders": "Mentorji",
    "states.award_level_complete": "Stopnja zaključena",
    "button.reset": "Ponastavi",
    "sidebar.my_award_unit": "Moja izvajalska organizacija",
    "pageTitle.all_aj_events": "Vse odprave",
    "label.activity": "Dejavnost",
    "moduleTitle.are_you_sure": "Ali si prepričan?",
    "route.gold_level": "Zlata stopnja",
    "table.evidence": "Priloge",
    "label.delivery_confirmed": "Soglasje prejeto",
    "parentalConsent.as_the_parent": "Kot starš/skrbnik dajem soglasje, da lahko Nacionalni urad MEPI in povezane organizacije vse slike uporabljajo za promocijske namene.",
    "label.awardMode.offline": "Tiskan indeks",
    "tasks.approve_registration": "Odobri registracijo",
    "note.change_the_email_will_change": "Pri spremembi e-naslova se bo spremenil tudi e-naslov premaknjenega kontakta",
    "notifications.participant_has_been_approved": "Udeleženec je potrjen.",
    "label.reached_activity_limit": "Udeleženec ima na vsakem področju lahko največ 3 dejavnosti.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "Oznaka je posodobljena.",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Priprave na odpravo so bile odstranjene.",
    "pageTitle.settings": "Nastavitve",
    "participant.level_registration_date": "Datum registracije – {value}",
    "notifications.question_has_been_removed": "Vprašanje je bilo odstranjeno.",
    "label.email_help_award_leader_full_name": "Ime in priimek mentorja.",
    "sidebar.leaders": "Mentorji",
    "notifications.participants_have_been_transferred": "Udeleženci so bili prestavljeni.",
    "tabs.assessors": "Ocenjevalci",
    "sidebar.dashboard": "Začetna stran",
    "pageTitle.independent_award_centers": "IAC-ji",
    "label.search": "Išči",
    "moduleTitle.office_labels": "Moje oznake",
    "label.note_from_participant": "Opomba udeleženca",
    "errors.required_field": "Obvezno polje",
    "tasks.approve_task": "Odobri opravilo",
    "logs.edit_log": "Uredi dnevniški zapis",
    "table.state": "Status",
    "moduleTitle.level_summary": "Povzetek trenutne stopnje",
    "moduleTitle.guides": "Vodiči",
    "modal.close": "Zapri",
    "label.parent_first_name": "Ime starša/skrbnika",
    "parentalConsent.i_understand_that_the_participant": "1. Razumem, da udeleženec/-ka ne more sodelovati v programu, dokler ta obrazec (vključno s soglasjem starša/skrbnika) ni izpolnjen in skupaj s plačano pristopnino oddan pristojni izvajalski organizaciji, ki mora prijavo tudi sprejeti.",
    "tabs.award_units": "Izvajalske organizacije",
    "table.hours": "Ure",
    "label.type": "Vrsta",
    "notifications.adventurous_journey_has_been_removed": "Pustolovska odprava je bila odstranjena",
    "label.aj_is_not_approved_yet": "Pustolovska odprava še ni odobrena",
    "roles.authorizing_contact": "Odgovorna oseba",
    "table.date_submitted_to_office_signoff": "Datum predložitve v potrditev uradu",
    "notifications.section_has_been_returned": "Področje je bilo vrnjeno v dopolnitev",
    "table.created_by": "Ustvaril/-a",
    "route.user_guide_web_participant": "Uporabniški priročnik za udeležence - spletna platforma",
    "route.templates": "Predloge",
    "states.awaiting_sign_off": "Potrditev mentorja",
    "table.phone": "Telefon",
    "label.parental_consent": "Soglasje starša/skrbnika",
    "label.org_contact_will_be_deleted": "Odstranili boste zadnjo vlogo, ki jo ima kontakt v tej organizaciji. Želite obdržati kontaktne informacije te osebe ali kontakt popolnoma izbrisati iz organizacije?",
    "route.bronze_level": "Bronasta stopnja",
    "label.invoice_currency": "Valuta na računu",
    "button.new_label": "Nova oznaka",
    "error.server_cannot_be_reached_at_the_moment": "S strežnikom trenutno ni mogoče vzpostaviti povezave. Poskusite znova pozneje. Če težava ne bo odpravljena, se obrnite na nacionalni urad.",
    "notifications.contact_has_been_created": "Kontakt je bil ustvarjen.",
    "pageTitle.profile_questions": "Predstavitvena vprašanja",
    "table.observation_files": "Datoteke opažanj",
    "table.participants": "Udeleženci",
    "tasks.no_evidence": "Ni prilog",
    "button.edit": "Uredi",
    "moduleTitle.leader": "Mentor",
    "notifications.new_template_has_been_updated": "Nova predloga je bila posodobljena.",
    "table.name": "Ime",
    "label.no_results": "Ni rezultatov",
    "moduleTitle.documents": "Dokumenti",
    "button.invite": "Povabi",
    "label.goal": "Cilj",
    "pageTitle.nao_award_units": "Nacionalni urad – izvajalske organizacije",
    "label.award_delete_participant_id": "ID udeleženca",
    "errors.at_least_num_characters": "Dolžina mora biti vsaj toliko znakov: {length}",
    "label.email_help_note": "Opomba (opcijsko).",
    "label.person_status.activating": "Aktivacija",
    "moduleTitle.remove_role": "Ali želite odstraniti vlogo?",
    "label.total": "Skupaj",
    "label.delete_participant_award_info": "Izbrisali boste stopnjo. Tega dejanja ni mogoče razveljaviti!",
    "route.leaders": "Mentorji",
    "table.start_date": "Datum začetka",
    "moduleTitle.coordinators": "Koordinatorji",
    "button.create": "Ustvari",
    "tabs.awards": "Priznanja",
    "parentalConsent.form_has_been_sent": "Soglasje starša je bilo poslano.",
    "states.journey_approval": "Odobritev odprave",
    "pageTitle.reports": "Poročila",
    "table.journey_type": "Vrsta odprave",
    "label.yes": "Da",
    "pageTitle.assessor_report": "Poročilo ocenjevalca",
    "label.organization": "Organizacija",
    "notifications.award_leader_has_been_updated": "Mentor je posodobljen.",
    "moduleTitle.edit_role": "Uredi vlogo",
    "table.journey_activity": "Vrsta dejavnosti",
    "label.location": "Kraj",
    "label.update_translations_error_item": "Neuspešna posodobitev prevodov za: {language}, koda: {localeCode}, projekt: {projectCode}. Razlog: ",
    "pageTitle.adventurous_journeys": "Pustolovske odprave",
    "global.assessor": "Ocenjevalec",
    "moduleTitle.profile_questions": "Predstavitvena vprašanja",
    "activity.cannot_edit_activity_if_award_in_state": "Dejavnosti ne moreš urejati, če je status udeleženca {state}.",
    "moduleTitle.assessor_detail": "Podatki o ocenjevalcu",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Razumem, da bo ob sprejemu v program MEPI pri izvajalski organizaciji udeleženec/-ka prejel/-a indeks dosežkov ali dobil/-a dostop do spletnega indeksa dosežkov (ORB). Udeleženec/-ka bo pred začetkom dejavnosti v indeksu dosežkov ali ORB-ju prebral/-a zahteve programa. Razumem, da ima izvajalska organizacija pravico določiti, ali so bile izpolnjene zahteve za priznanje in ali se na tej podlagi izda bronasto, srebrno ali zlato priznanje. Razumem, da lahko izvajalska organizacija udeležencem priskrbi omejeno zavarovanje glede osebnih nesreč in zavarovanje splošne odgovornosti ob sprejemu v program izvajalske organizacije, a da je odgovornost za pridobitev in vzdrževanje osebnega zavarovanja na udeležencu/-ki in njegovih/njenih starših/skrbnikih.",
    "notifications.award_has_been_returned": "Priznanje je zavrnjeno",
    "label.code_of_conduct": "Kodeks",
    "button.new_contact": "Nov kontakt",
    "tabs.payments": "Plačila",
    "roles.naa_oa_staff": "Nacionalni urad",
    "label.switch_organisation_hint": "To pogovorno okno lahko vedno odpreš, če v zgornjem desnem meniju izbereš »Zamenjaj organizacijo«.",
    "label.expiration_date": "Datum poteka",
    "tabs.participants": "Udeleženci",
    "table.practice": "Poskusna",
    "notifications.one_activity_has_to_remain": "Ena dejavnost na področju mora biti aktivna.",
    "label.qualifications": "Izobrazba",
    "states.organization_approval": "Potrditev nacionalnega urada",
    "errors.must_be_an_integer": "Mora biti celo število",
    "participant.send_confirmation_email_again_question": "Ponovno pošljem potrditveno sporočilo?",
    "button.dismiss": "Opusti",
    "table.advice": "Nasvet",
    "label.years_of_working_experience": "Leta delovnih izkušenj",
    "notifications.search_failed": "Napaka pri iskanju. Poskusite znova pozneje.",
    "notifications.changes_have_been_saved": "Spremembe so bile shranjene",
    "moduleTitle.resend_parental_consent_link": "Ponovno pošiljanje povezave za dostop do obrazca za soglasje starša?",
    "label.activity_type": "Vrsta dejavnosti",
    "label.change_award": "Spremeni stopnjo programa",
    "label.email": "E-naslov",
    "button.remove": "Odstrani",
    "button.download": "Prenesi",
    "label.vat_treatment": "Obračun DDV-ja",
    "pageTitle.aj_template_new": "Nova predloga pustolovske odprave",
    "table.per_page": "na stran",
    "notifications.translations_has_been_updated": "Prevodi so bili posodobljeni",
    "notification.award_mode_has_been_updated": "Način beleženja Programa MEPI je bil posodobljen",
    "tasks.revise_item": "Vrni element v dopolnitev",
    "button.resend_parental_consent": "Ponovno pošlji soglasje starša",
    "table.weeks_completed_required": "Št. opravljenih tednov",
    "label.last_modified": "Zadnjič spremenjeno",
    "table.major": "Glavno področje",
    "label.vat_number": "Davčna številka",
    "errors.passwords_dont_match": "Gesli se ne ujemata",
    "table.country": "Država",
    "sidebar.guides_and_policies": "Dokumenti",
    "notifications.question_has_been_updated": "Vprašanje je bilo posodobljeno.",
    "table.participant_name": "Ime udeleženca",
    "label.registration_approval_date": "Datum odobritve registracije",
    "notifications.auth_code_is_no_longer_valid": "Avtorizacijska koda ni več veljavna.",
    "errors.must_be_no_more_than": "Največje število znakov: {max}",
    "notifications.event_has_been_rejected": "Odprava je bila zavrnjena",
    "tabs.customizations": "Napredne možnosti",
    "label.name_organization": "Naziv",
    "button.add_log": "Dodaj dnevniški zapis",
    "moduleTitle.invite_assessor": "Povabi ocenjevalca",
    "label.resend_confirmation_email": "Ponovno pošlji potrditveno sporočilo",
    "text.all_participants_will_be_transfered": "Vsi udeleženci bodo premaknjeni k novemu mentorju.",
    "label.repeat_email": "Ponovi e-naslov",
    "errors.email_or_phone_required": "Zahtevan je e-poštni naslov ali telefon",
    "notifications.role_has_been_updated": "Vloga je bila posodobljena.",
    "roles.if_staff_stat_user": "Up. statističnih funkcij (IAF)",
    "participant.delete_account": "Izbriši račun",
    "moduleTitle.would_you_like_to_remove_this_log": "Ali želite izbrisati ta dnevniški vnos?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "Pripravi novo e-sporočilo",
    "table.journey_category": "Tip odprave",
    "sidebar.manual_data_import": "Ročni uvoz podatkov",
    "label.created_after_date": "Ustvarjeno po",
    "route.my_organization": "Moja organizacija",
    "button.show_list": "Pokaži seznam",
    "label.leaders": "Mentorji",
    "notifications.log_has_been_modified": "Dnevniški vnos je bil spremenjen.",
    "button.upload_file": "Naloži datoteko",
    "moduleTitle.which_section_do_you_want_to": "Katero področje želite vrniti v stanje »V teku«?",
    "tabs.bronze_level": "Bronasta stopnja",
    "notifications.participants_have_been_saved": "Udeleženci so shranjeni.",
    "pageTitle.aj_template_detail": "Pustolovska odprava",
    "label.parent_email": "E-naslov starša/skrbnika",
    "map.appr_location": "Približen naslov",
    "notifications.log_has_been_removed": "Dnevniški vnos je bil odstranjen.",
    "notifications.label_has_been_assigned": "Oznaka je bila dodeljena.",
    "pageTitle.tasks_undelivered_emails": "Nedostavljena e-pošta",
    "button.stay": "Ostani",
    "table.previous_level": "Prejšnja stopnja",
    "label.award_start_date": "Datum vstopa v program",
    "assessor_report.returned_to_participant": "Vrnjeno udeležencu",
    "pageTitle.tasks_assessors_registration": "Registracija ocenjevalca",
    "aj.cannot_modify_award": "Če so udeleženci dodani pustolovski odpravi, stopnje odprave ni mogoče več spreminjati.",
    "moduleTitle.lost_internet_connection": "Ni internetne povezave",
    "states.ceremony": "Podelitev",
    "participant.reactivate_account": "Znova aktiviraj račun",
    "label.birthdate": "Datum rojstva",
    "pageTitle.assessment_send_successfully": "Ocena uspešno poslana",
    "states.assessor_approval": "Vpis ocene",
    "award.change_award_level": "Spremeni stopnjo programa",
    "label.url_no_longer_valid": "Ta URL ni več veljaven.",
    "button.update": "Posodobi",
    "label.secondary_email": "Dodatni e-naslov",
    "button.role_edit": "Uredi",
    "table.award_leader": "Mentor",
    "label.level": "Stopnja",
    "tasks.evidence": "Priloge",
    "notifications.participant_is_already_in_list": "Udeleženec je že na seznamu.",
    "button.clear": "Počisti",
    "label.allow_log_after_25_yoa": "Dovoli dodajanje dnevniških zapisov po 25. letu starosti",
    "states.setup": "Nastavitev",
    "table.activity": "Dejavnost",
    "label.copy_to_clipboard": "Uspešno kopirano v odložišče.",
    "route.award_units": "Izvajalske organizacije",
    "button.upload_photo": "Naloži sliko",
    "table.hours_completed_required": "Št. opravljenih ur",
    "table.first_name": "Ime",
    "notifications.adventurous_journey_has_been_returned": "Pustolovska odprava vrnjena v dopolnitev",
    "pageTitle.national_offices": "Nacionalni uradi",
    "notifications.you_have_been_logged_in": "Prijava je uspela.",
    "logs.offline": "Tiskan indeks",
    "moduleTitle.add_role": "Dodaj vlogo",
    "label.user_app_guide_participant": "Priročnik za uporabnike (aplikacija - udeleženci)",
    "notifications.file_has_been_removed": "Datoteka je bila odstranjena.",
    "label.send_message": "Pošlji sporočilo",
    "button.select": "Izberi",
    "label.reason_of_deletion": "Razlog za brisanje računa",
    "label.user_guide": "Priročnik za uporabnike",
    "pageTitle.nao_participants": "Nacionalni urad – udeleženci",
    "tabs.sub_operating_partners": "Lokalni uradi",
    "table.uploaded_by": "Naložil/-a",
    "tasks.approve_item": "Odobri element",
    "tasks.restore_participant_registration": "Ali želite obnoviti registracije udeležencev?",
    "label.awardMode.hybrid": "ORB + tiskan indeks",
    "table.first_activity_started": "Začetek prve dejavnosti",
    "moduleTitle.dates": "Datumi",
    "table.no_results": "Ni rezultatov",
    "states.registration_approval": "Potrditev registracije",
    "table.breakdown_of_hours": "Porazdelitev ur",
    "pageTitle.tasks_registration": "Registracija udeležencev",
    "button.create_new": "Ustvari novo",
    "sidebar.todolist": "Vsa opravila",
    "label.active_participants": "Aktivni udeleženci",
    "moduleTitle.postalAddress": "Poštni naslov",
    "tasks.return_task": "Vrni opravilo v dopolnitev",
    "organisation.change_organisation_state": "Spremeni stanje organizacije",
    "moduleTitle.roles": "Vloge",
    "label.no_config_key_available": "Konfiguracijski ključi niso na voljo za to področje",
    "placeholder.selectLanguage": "Izberi jezik",
    "states.office_signoff": "Potrditev nacionalnega urada",
    "notifications.translations_has_been_updated.failure": "Napaki pri posodabljanju prevodov",
    "logs.minute": "min",
    "label.last_activity": "Zadnja dejavnost",
    "sidebar.user_guide": "Uporabniški priročniki",
    "label.trained_award_leader": "usposobljen mentor",
    "table.progress": "Napredek",
    "table.suboperating_authorities": "Lokalni uradi",
    "activity.cannot_edit_activity_offline": "Če ima udeleženec tiskan indeks, ni mogoče urejati dejavnosti, pustolovske odprave ali PNP.",
    "label.user_does_not_have_permissions": "Uporabnik <strong>{user}</strong> nima dovoljenja za dostop do te vsebine.",
    "notifications.assessor_has_been_approved": "Ocenjevalec je bil odobren",
    "route.activity_approval": "Odobritev dejavnosti",
    "moduleTitle.role": "Vloga",
    "button.run": "Zaženi",
    "label.to": "Za",
    "notifications.file_has_been_updated": "Datoteka je bila posodobljena.",
    "moduleTitle.edit_coordinator": "Uredi koordinatorja",
    "notifications.authorization_code_is_no_longer_valid": "Avtorizacijska koda ni več veljavna.",
    "button.reject": "Zavrni",
    "label.label.participant_status": "Status udeleženca",
    "award.gold_level": "Zlata stopnja",
    "sidebar.variables": "Spremenljivke",
    "parentalConsent.checkbox_copy": "Potrjujem, da sem starš/skrbnik osebe {firstName} {lastName}. Soglašam, da lahko sodeluje v programu MEPI v organizaciji {organisationName} pod vodstvom izkušenega mentorja. Prebral/-a sem, razumem in se strinjam s zahtevami in pogoji programa, kot so opisani zgoraj in na spletni strani urada MEPI.",
    "button.go_to_dashboard": "Pojdi na začetno stran",
    "button.add_option": "Dodaj možnost",
    "label.is_completed": "Zaključeno",
    "pageTitle.award_units": "Izvajalske organizacije",
    "states.completed": "Zaključeno",
    "button.adventurous_journey_template_settings": "Nastavitve predloge pustolovske odprave",
    "label.system_rights": "Sistemske pravice",
    "label.assessor_assesstment_award_start_date": "Datum vstopa v program",
    "label.update_translation_question": "Prevodi za vse izbrane jezike bodo posodobljeni.",
    "button.login": "Prijava",
    "label.name_of_the_unit": "Ime organizacije",
    "button.send": "Pošlji",
    "award.ajs": "Pustolovske odprave",
    "meta.payments_expired": "Plačila – potekla",
    "label.age": "Starost",
    "notifications.payment_info_updated": "Podatki o plačilu so posodobljeni.",
    "table.is_completed": "Zaključeno",
    "table.invited_by": "Vabilo poslal/-a:",
    "route.files": "Datoteke",
    "route.assessors": "Ocenjevalci",
    "info.aj_supervisor_is_mandatory": "Pozor! Prošnjo za ocenjevanje poskusne odprave prejme spremljevalec, prošnjo za ocenjevanje kvalifikacijske odprave pa ocenjevalec.",
    "pageTitle.my_participants": "Moji udeleženci",
    "label.change_leader_status": "Spremeni status mentorja",
    "moduleTitle.parent_consent_form": "Obrazec za soglasje starša/skrbnika",
    "notifications.authorization_contact_has_been_set": "Odgovorna oseba je določena.",
    "button.close": "Zapri",
    "label.independent_country": "Neodvisna država",
    "notifications.aj_preparation_training_has_been_returned": "Priprave na odpravo vrnjene v dopolnitev",
    "route.history_log": "Zgodovina vnosov",
    "participant.account_settings": "Nastavitve računa",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email}, ker\n",
    "label.orb_account": "ORB račun",
    "notifications.file_url_is_not_specified_in_configuration": "URL datoteke ni določen",
    "notifications.award_unit_has_been_removed": "Izvajalska organizacija je odstranjena",
    "table.parent": "Starši",
    "label.mode_of_transport": "Način potovanja",
    "label.parental_consent_email_info": "Ne pozabi preveri e-naslova staršev in poslati soglasja.",
    "label.current_award": "Trenutna stopnja",
    "table.action": "Dejanje",
    "pageTitle.suboperating_authorities": "Lokalni uradi",
    "notifications.award_leader_has_been_assigned": "Mentor je dodeljen",
    "tabs.sign_offs_locally": "Potrditve na ravni organizacije",
    "Activity log has been restored": "Dnevnik dejavnosti je bil obnovljen.",
    "sidebar.naos": "Nacionalni uradi",
    "tabs.aj_templates": "Predloge pustolovskih odprav",
    "notifications.logging_out": "Odjavljanje ...",
    "label.update_label": "Posodobi oznako",
    "button.organisation_settings": "Nastavitve organizacije",
    "tabs.independent_award_centers": "IAC-ji",
    "label.current": "Nedavno",
    "table.location": "Kraj",
    "button.search": "Išči",
    "notifications.aj_preparation_training_has_been_approved": "Priprave na odpravo so potrjene",
    "route.participants": "Udeleženci",
    "label.other_location_information": "Dodatni podatki o območju odprave",
    "label.number_of_records": "Število zapisov",
    "translationsManagement.infoLabel": "Informacije o upravljanju prevodov",
    "parentalConsent.i_consent_to_pay_all": "5. Strinjam se, da poravnam vse stroške za bolnišnično oskrbo in namestitev udeleženca/-ke, ki bi bili posledica tovrstnih nezgod, nesreč, bolezni ali izgube, ki jih utrpi udeleženec/-ka med sodelovanjem pri ali potovanjem do/od dejavnosti, povezanih s programom MEPI.",
    "label.nationality": "Državljanstvo",
    "states.approval": "Odobritev ciljev",
    "notifications.something_went_wrong": "Nekaj je šlo narobe.",
    "aj.practice": "Poskusna",
    "label.addressLine2": "Dodatna vrstica za naslov (neobvezno)",
    "label.please_leave_a_note": "Dodajanje sporočila",
    "placeholder.select": "Izberi",
    "label.observations": "Poročilo",
    "label.aim": "Cilj",
    "label.addressLine1": "Ulica in hišna številka",
    "roles.aj_instructor": "Voditelj pustolovske odprave",
    "meta.payments_waiting": "Plačila – čakanje",
    "label.award_to_delete": "Stopnja za izbris",
    "label.category": "Kategorija",
    "roles.instructor": "Inštruktor",
    "moduleTitle.remove_customization_and_reset": "Odstranitev nastavitev po meri in ponastavitev konfiguracijske vrednost?",
    "notifications.participant_registration_has_been_restored": "Registracija udeleženca je bila obnovljena.",
    "organisation.change_award_unit_mode": "Spremeni način beleženja Programa MEPI",
    "table.organization_type": "Vrsta organizacije",
    "notifications.participant_has_been_deleted": "Udeleženec je izbrisan.",
    "label.language_settings": "Nastavitve jezika",
    "notifications.event_has_been_approved": "Odprava je odobrena.",
    "label.password": "Geslo",
    "label.text": "Besedilo",
    "table.observations": "Poročilo",
    "notifications.participant_has_been_created": "Udeleženec je bil ustvarjen.",
    "table.note_for_al": "Opomba za mentorja",
    "label.payment_confirmed": "Plačilo potrjeno",
    "label.previous_completed_award_level": "Prejšnja stopnja (tiskani indeks)",
    "pageTitle.new_aj_event": "Nova odprava",
    "label.backend": "Backend",
    "label.relationship_to_participant": "Sorodstveno razmerje do udeleženca",
    "award.physical_recreation": "Rekreativni šport",
    "contact.collect_emails": "Izvozi e-naslove",
    "moduleTitle.assessor_report_reject": "Zavrnjeno poročilo ocenjevalca",
    "label.supervisor_report": "Poročilo spremljevalca",
    "table.role": "Vloga",
    "route.user_guide_web_nao": "Uporabniški priročnik za nacionalni urad - spletna platforma",
    "label.page_not_found": "404 – strani ni mogoče najti.",
    "table.labels": "Oznake",
    "notifications.file_has_been_uploaded": "Datoteka je bila naložena.",
    "moduleTitle.address": "Naslov",
    "moduleTitle.lead_coordinator": "Glavni koordinator",
    "pageTitle.login": "Prijava",
    "label.frontoffice": "Frontoffice",
    "participant.would_you_like_to_remove_registration": "Ali res želite izbrisati to registracijo?",
    "notifications.rp_has_been_setup": "PNP je nastavljen.",
    "moduleTitle.award_unit": "Izvajalska organizacija",
    "button.remove_file": "Odstrani datoteko",
    "moduleTitle.billing_address": "Naslov za plačilo",
    "pageTitle.my_aj_events": "Moje odprave",
    "route.tasks": "Opravila",
    "button.confirm": "Potrdi",
    "label.national_award_authority": "Nacionalni urad",
    "label.independent_award_centre": "IAC",
    "award.generate_award_report": "Ustvari poročilo",
    "route.my_region_office_customization": "Regionalna pisarna - po meri",
    "label.email_help_aj_category": "Vrsta odprave.",
    "label.your_report_has_been_rejected": "Zavrnili ste vpis ocene",
    "notifications.password_change_request_has_been_sent": "Zahteva za spremembo gesla je bila poslana.",
    "tabs.detail": "Osnovni podatki",
    "participant.change_participant_status": "Spremeni status udeleženca",
    "table.key": "Ključ",
    "label.find_address": "Najdi naslov",
    "notifications.assessor_has_been_rejected": "Ocenjevalec je zavrnjen",
    "label.transfer_participants": "Premakni udeležence",
    "button.continue_to_payment_gateway": "Nadaljuj do plačilnega prehoda",
    "notifications.participant_registration_has_been_removed": "Registracija udeleženca je bila odstranjena",
    "moduleTitle.page_not_found": "404 – strani ni bilo mogoče najti",
    "route.adventurous_journeys": "Pustolovske odprave",
    "states.registration_assessment": "Pregled registracije",
    "heading.change_award_unit_mode": "Spremeni način beleženja Programa MEPI",
    "label.user_guide_web_nao": "Priročnik za uporabnike (splet - nacionalni urad)",
    "tabs.silver_level": "Srebrna stopnja",
    "table.paid_by": "Plačal/-a",
    "label.your_report_has_been_successfully_sent": "Poročilo uspešno poslano.",
    "sidebar.my_organization": "Nastavitve organizacije",
    "pageTitle.participants": "Udeleženci",
    "notifications.preparation_training_has_been_updated": "Priprave na odpravo so posodobljene.",
    "moduleTitle.server_is_unreachable": "Strežnik ni dosegljiv.",
    "label.last_activity_date": "Datum zadnje aktivnosti",
    "award.bronze_level": "Bronasta stopnja",
    "moduleTitle.award_units": "Izvajalske organizacije",
    "table.completed": "Zaključeno",
    "moduleTitle.revise_message": "Sporočilo o dopolnitvi",
    "table.lastUsed": "Nazadnje uporabljeno",
    "award.bronze_to_gold_level": "Z bronaste na zlato stopnjo",
    "button.change_password": "Spremeni geslo",
    "label.nao_price": "Cena nacionalnega urada",
    "label.payment_state": "Stanje plačila",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "Datum potrditve nacionalnega urada",
    "label.award_unit": "Izvajalska organizacija",
    "award.gold_level_short": "Zlata",
    "moduleTitle.other_info": "Drugi podatki",
    "table.note": "Opomba",
    "label.search_by_email_first_or_last": "Išči po e-naslovu, imenu ali priimku",
    "tabs.history": "Zgodovina",
    "notifications.label_has_been_created": "Oznaka je bila ustvarjena.",
    "tabs.unassigned_participants": "Udeleženci brez mentorja",
    "table.main_award_leader": "Koordinator",
    "parentalConsent.i_as_the_parent": "3. Razumem, da so nekatere dejavnosti povezane z večjimi tveganji in da zavarovanje izvajalske organizacije morda ne pokriva teh dejavnosti. Razumem, da je odgovornost za vsa tveganja, ki bi nastala ob sodelovanju udeleženca/-ke v programu, izključno na udeležencu/-ki.",
    "label.state": "Status",
    "notifications.award_leader_has_been_removed": "Mentor je bil odstranjen.",
    "tabs.organization_detail": "Podrobnosti organizacije",
    "table.operating_authorities": "Regionalni uradi",
    "label.available_labels": "Razpoložljive oznake",
    "modal.select": "Izberi",
    "tabs.expired_payments": "Potekla plačila",
    "moduleTitle.note_for_al": "Opomba za mentorja",
    "moduleTitle.confirm": "Potrdi",
    "notification.new_activity_added": "Nova dejavnost je bila dodana",
    "notifications.award_leader_has_been_moved": "Mentor je bil premaknjen.",
    "label.award_mode": "Način beleženja Programa MEPI",
    "label.phone": "Telefon",
    "notifications.organization_has_been_updated": "Organizacija je bila posodobljena.",
    "moduleTitle.assessor": "Ocenjevalec",
    "label.bulk_action_confirmation": "Potrditev spremembe označenih elementov",
    "table.parent_approval": "Soglasje starša",
    "label.date_of_delivery": "Datum prejema soglasja",
    "sidebar.assessors": "Ocenjevalci",
    "label.journey_activity": "Vrsta dejavnosti",
    "award.inactive_award": "Deaktiviraj udeleženca",
    "label.end_date": "Datum zaključka",
    "label.orb_testing": "Testiranje ORB",
    "label.no_activities": "Ni dejavnosti",
    "moduleTitle.please_confirm": "Potrditev",
    "button.login_with_another_account": "Prijava z drugim računom",
    "tasks.reject_registration": "Zavrni registracijo",
    "label.submitted_after_date": "Oddano po - izberi datum",
    "label.update_translations_successful": "{count} elementov uspešno posodobljenih.",
    "button.assign_leader": "Dodeli mentorja",
    "table.already_running": "Že v teku",
    "label.no": "Ne",
    "label.count_items_selected": "{count} izbranih elementov",
    "label.secondary_phone_number": "Dodatna telefonska številka",
    "label.my_experience": "Moje izkušnje",
    "notifications.adventurous_journey_has_been_approved": "Pustolovska odprava je odobrena.",
    "pageTitle.mro_detail": "Regionalna pisarna IAF - podrobnosti",
    "moduleTitle.nao_specific_info": "Specifični podatki Nacionalnega urada MEPI",
    "label.preparing_document_for_import": "Priprava dokumenta za uvoz",
    "tasks.observations": "Opažanja",
    "notifications.confirmation_email_has_been_sent": "Potrditveno sporočilo je bilo poslano.",
    "button.restore": "Obnovi",
    "label.importing_file": "Uvažanje datoteke",
    "label.or_dont_agree": "Če menite, da udeleženec ni zadostil kriterijem, lahko ",
    "moduleTitle.award_leader": "Mentor",
    "label.me": "(jaz)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Izvozi tabelo",
    "organisation.move_award_unit": "Premakni izvajalsko organizacijo",
    "label.file_category": "Kategorija dokumenta",
    "notifications.connecting_to_server": "Povezovanje s strežnikom ...",
    "parentalConsent.i_understand_that_a_and_b": "11. Razumem, da: <br />a) udeleženec/-ka ne sme voziti motornega vozila ali prevažati drugih udeležencev, ki sodelujejo v dejavnostih, povezanih s programom MEPI, razen če ima udeleženec/-ka primerno in veljavno vozniško dovoljenje ter ustrezno zavarovanje za civilno odgovornost, ki pokriva poškodbo vseh oseb, poškodovanih zaradi udeleženčevega upravljanja vozila; in  <br />b) udeleženca/-ke ne sme prevažati nihče, ki ni udeležen ali ne pomaga pri organizaciji programa MEPI za namene sodelovanja v njem, razen če ima primerno in veljavno vozniško dovoljenje ter ustrezno zavarovanje za civilno odgovornost, ki pokriva poškodbo vseh oseb, poškodovanih v trenutku, ko je zadevna oseba upravljala vozilo.",
    "table.reason": "Razlog",
    "pageTitle.contacts": "Kontakti",
    "states.award_leader_approval": "Potrditev mentorja",
    "meta.payments": "Plačila",
    "label.suboperating_authority": "Lokalni urad",
    "route.my_region_office": "Regionalna pisarna",
    "states.registration_not_approved": "Registracija ni odobrena",
    "label.direct_entrant": "Direktni vstopnik",
    "tabs.all_participants": "Vsi udeleženci",
    "tabs.payment": "Nastavitve plačil",
    "label.email_help_activity_name": "Naziv dejavnosti",
    "title.update_report": "Poročilo o posodobitvah",
    "label.repeat_new_password": "Ponovi novo geslo",
    "label.other_roles": "Prikaži ostale vloge",
    "logs.hours": "h",
    "notifications.spreadsheet_has_been_imported_successfully": "Preglednica je bila uspešno uvožena",
    "label.bulk_action_question": "Izvedem spremembo na {count} elementih?",
    "moduleTitle.personal_details": "Osebni podatki",
    "label.bulk_action_emailing": "E-naslovi izbranih udeležencev",
    "route.my_events": "Moji dogodki",
    "button.delete_award": "Izbriši stopnjo",
    "errors.include_both_lower_and_upper_case": "Vsebovati mora velike in majhne črke",
    "tabs.removed_participant_registrations": "Izbrisane registracije udeležencev",
    "sidebar.mynao": "Nastavitve organizacije",
    "tabs.office_details": "Podatki o organizaciji",
    "label.major": "Glavno področje",
    "tabs.documents": "Dokumenti",
    "label.new_password": "Novo geslo",
    "sidebar.adventure_journey": "Pustolovske odprave",
    "pageTitle.customizations": "Po meri",
    "moduleTitle.assessor_report": "Poročilo: {role}",
    "label.registration_date": "Datum registracije",
    "notifications.training_has_been_added": "Usposabljanje je bilo dodano.",
    "aj.qualifying": "Kvalifikacijska",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Seja je potekla",
    "award.service": "Prostovoljstvo",
    "notifications.rp_state_has_been_changed": "Stanje PNP je spremenjeno.",
    "label.ctest_access": "CTEST dostop",
    "table.created": "Ustvarjeno",
    "tasks.revise_task": "Vrni opravilo v dopolnitev",
    "button.assign": "Dodeli",
    "button.return": "Vrni v dopolnitev",
    "table.status": "Status",
    "button.restore_activity": "Obnovi dejavnost",
    "tabs.new_aj_event": "Nova odprava",
    "roles.if_staff_viewer": "Up. z osnovnimi pooblastili (IAF)",
    "notifications.new_template_has_been_created": "Nova predloga je bila ustvarjena.",
    "global.something_went_wrong": "Nekaj je šlo narobe",
    "table.expire_day": "Dan poteka",
    "tabs.history_log": "Dnevnik zgodovine",
    "label.form_of_payment": "Način plačila",
    "button.add_training": "Dodaj usposabljanja",
    "label.par_reg_cust_note": "Ta zavihek omogoča prilagoditev prikazovanja določenih polj v procesu registracije udeležencev. Za spremembo teh nastavitev se obrnite na regionalno pisarno mednarodne fundacije.",
    "label.my_qualification": "Moja izobrazba",
    "button.add_new_profile_question": "Dodaj novo vprašanje",
    "table.operating_authority": "Regionalni urad",
    "table.aim": "Namen",
    "table.awards": "Priznanja",
    "participant.deactivate_account": "Deaktiviraj račun",
    "table.organization_name": "Organizacija",
    "label.email_help_award_leader_first_name": "Ime mentorja.",
    "table.date": "Datum",
    "tasks.would_you_like_to_delete": "Ali želite izbrisati tega udeleženca?",
    "notifications.configuration_value_has_been_updated": "Konfiguracijska vrednost je bila posodobljena.",
    "ajTemplates.fill_from_template": "Ustvari odpravo iz predloge",
    "contact.send_test_email": "Pošlji preizkusno e-poštno sporočilo",
    "moduleTitle.aj_preparation_and_training": "Priprave na odpravo",
    "label.ce_be": "Prevodi sistemskih sporočil",
    "button.notify_participant": "Obvesti udeleženca",
    "label.parent_phone": "Telefonska številka starša/skrbnika",
    "label.nao_regulations": "Pravila nacionalnega urada",
    "award.skills": "Veščine",
    "label.reject_application": "prošnjo za vpis ocene zavrnete.",
    "leader.delete_account": "Izbriši račun",
    "table.assign": "Dodeli",
    "roles.aj_supervisor": "Spremljevalec pustolovske odprave",
    "label.logout": "Odjava",
    "moduleTitle.award_leader_edit": "Uredi mentorja",
    "moduleTitle.training": "Usposabljanja",
    "notifications.coordinator_has_been_removed": "Koordinator je bil odstranjen.",
    "tabs.operating_partners": "Regionalni uradi",
    "moduleTitle.main_award_leader": "Koordinator",
    "label.bulk_action_successful": "{count} elementov uspešno posodobljenih.",
    "tasks.clear_email_revision": "Počisti",
    "table.preparation": "Priprave",
    "table.delete": "Izbriši",
    "label.safeguarding_policy": "Politika zaščite otrok",
    "sidebar.reports": "Poročila",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "Udeleženec že ima glavno dejavnost na drugi stopnji programa. Res želite dodati še eno glavno dejavnost?",
    "pageTitle.operating_authorities": "Nacionalni uradi",
    "label.delete_participant_award_modal_question_detail": "Ali res želiš izbrisati stopnjo ({awardLevel}) pri udeležencu {participantId}?",
    "label.confirmed": "Potrjeno",
    "notifications.invitation_has_been_sent": "Vabilo je bilo poslano.",
    "pageTitle.independent_countries": "Neodvisne države",
    "label.assessors_email": "E-naslov ocenjevalca",
    "tasks.approve_assessor_registration": "Odobri registracijo ocenjevalca",
    "table.award_duration": "Trajanje programa",
    "notifications.organization_has_been_moved": "Organizacija je bila premaknjena",
    "pageTitle.nao_payment": "Nacionalni urad – plačilo",
    "participant.history_log": "Dnevnik zgodovine",
    "label.rejected_with_note": "Opomba ob zavrnitvi: \"{note}\"",
    "label.already_running": "Že v teku",
    "button.continue": "Nadaljuj",
    "award.no_data_to_show": "Ni podatkov za prikaz",
    "participant.send_email_invitation_again_question": "Ponovno pošiljanje e-poštnega vabila",
    "label.reason_for_changing_assessor": "Razlog za menjavo ocenjevalca",
    "button.delete": "Izbriši",
    "moduleTitle.requirements_and_conditions": "Zahteve in pogoji",
    "roles.leader": "Mentor",
    "label.if_download_doesnt": "Če se prenos ne začne samodejno, preverite pojavno okno v brskalniku.",
    "dashboard.your_todo_list": "Seznam opravil",
    "notifications.award_unit_has_been_returned": "Izvajalska organizacija je bila vrnjena v dopolnitev",
    "moduleTitle.participant_activities": "Dejavnosti udeleženca",
    "errors.qualification_or_experience_required": "Vnos izobrazbe ali izkušenj je obvezen",
    "label.active_leaders": "Aktivni mentorji",
    "aj.preparation": "Priprave na odpravo",
    "button.change_state": "Spremeni status",
    "label.current_password": "Trenutno geslo",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Nastavitve kontakta",
    "button.remove_photo": "Odstrani fotografijo",
    "notifications.activity_has_been_setup": "Dejavnost je nastavljena.",
    "errors.must_be_more_than": "Mora biti več kot {limit}",
    "table.goal": "Cilj",
    "notifications.coordinator_has_been_set": "Koordinator je določen.",
    "label.cc": "Kp",
    "label.duration": "Trajanje",
    "table.actions": "Dejanja",
    "participant.send_email_invitation_again": "Ponovno pošiljanje e-poštnega vabila",
    "moduleTitle.would_you_like_to_remove_participant": "Ali želite izbrisati registracijo tega udeleženca?",
    "parentalConsent.i_authorise_employees": "4. Pooblaščam uslužbence, uradnike in izvajalce v izvajalski organizaciji ter druge posameznike, ki sodelujejo, so udeleženi ali pomagajo pri organizaciji programa MEPI, da v primerih nezgode, nesreče, bolezni in izgube, ki jih utrpi udeleženec/-ka med sodelovanjem pri ali prevozu do/od dejavnosti, povezanih s programom MEPI, lahko pridobijo potrebno zdravniško pomoč ali oskrbo, vključno z vendar ne omejeno na pomoč zdravnikov, medicinskih sester ali bolnišnično namestitev.",
    "button.reload_page": "Ponovno naloži stran",
    "moduleTitle.update_translations": "Posodobi prevode",
    "label.report_description": "Poročila so trenutno na voljo zgolj v angleščini. Delamo na tem, da bodo v prihodnosti na voljo tudi v slovenščini.",
    "table.email": "E-naslov",
    "label.new_goal": "Nov cilj",
    "label.participant_survey_parent": "Strinjam se, da moj otrok {firstName} {lastName} sodeluje v anketah, ki preverjajo kakovost uporabniške izkušnje udeležencev in merijo rezultate in učinke Programa MEPI.",
    "errors.invalid_email_address": "Neveljaven e-naslov",
    "pageTitle.new_contact": "Nov kontakt",
    "sidebar.gops": "",
    "button.manage_participants": "Uredi udeležence",
    "errors.invalid_phone_format": "Neveljavna telefonska številka",
    "notifications.login_details_have_been_changed": "Podatki za prijavo so spremenjeni.",
    "moduleTitle.participant_logs": "Dnevniški zapisi udeleženca",
    "label.save": "Shrani",
    "label.frequently_asked_questions": "Pogosta vprašanja",
    "label.city": "Pošta",
    "notifications.configuration_value_has_been_reset": "Konfiguracijska vrednost je bila ponastavljena.",
    "states.office_sign_off": "Potrditev nacionalnega urada",
    "button.save": "Shrani",
    "button.import_data_from_selected_file": "Uvozi podatke iz izbrane datoteke",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Razumem, da udeleženec/-ka ne more začeti z določenim področjem programa MEPI, preden se ne prepričam, da so vsi prostovoljci, ki si jih udeleženec/-ka izbere in niso zaposleni v izvajalski organizaciji, primerno izkušeni in/ali usposobljeni za spremljanje udeleženca in poučevanje/ocenjevanje tega področja; in dokler prostovoljci niso izpolnili in vrnili zahtevane dokumentacije izvajalski organizaciji.",
    "pageTitle.apiKeys": "API ključ",
    "label.international_region": "Mednarodna regija",
    "tabs.levels": "Stopnje",
    "tabs.additional_files": "Dodatne datoteke",
    "label.continuation_level": "Stopnja - nadaljevanje",
    "table.adventurous_journey_detail": "Podrobnosti o pustolovski odpravi",
    "button.set": "Nastavi",
    "label.i_certify_that_as_the_assessor": "Kot {role} te dejavnosti potrjujem, da je udeleženec zadostil zahtevam.",
    "table.coordinator": "Koordinator",
    "participant.send_confirmation_email_again": "Ponovno pošlji potrditveno sporočilo",
    "table.report": "Poročilo",
    "label.update_translations_results": "Rezultat posodobitve prevodov",
    "table.observation_note": "Vtisi udeleženca",
    "label.view_more": "Poglej več",
    "notifications.payment_link_has_been_reset": "Povezava na plačilo je bila ponastavljena.",
    "table.type": "Vrsta",
    "moduleTitle.updateConfigurationKey": "Posodobi konfiguracijski ključ",
    "sidebar.independent_award_centers": "IAC-ji",
    "table.activity_type": "Vrsta dejavnosti",
    "label.awardMode.online": "ORB",
    "table.data_state": "Datum zadnje osvežitve podatkov",
    "button.generate_report": "Ustvari poročilo",
    "moduleTitle.assessed_by_award_leader": "Ocenil mentor",
    "table.child_protection_number": "Številka potrdila o nekaznovanosti",
    "button.bulk_change": "Izvedi za vse označene",
    "label.send_welcome_email": "Pošlji informacije področnemu inštruktorju",
    "label.award_state": "Stanje stopnje",
    "moduleTitle.overview": "Pregled",
    "table.aj_detail": "Podrobnosti o pustolovski odpravi",
    "pageTitle.tasks_activity_approvals": "Odobritve dejavnosti",
    "label.section": "Področje",
    "route.history": "Zgodovina",
    "route.event_participants": "Udeleženci odprave",
    "participant.account_detail": "Nastavitve računa",
    "route.dashboard": "Začetna stran",
    "table.payments": "Plačila",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Odstrani organizacijo",
    "pageTitle.my_organization": "Moja organizacija",
    "label.award_leader": "Mentor",
    "notifications.assessor_has_been_updated": "Ocenjevalec je bil posodobljen.",
    "label.participant_personal_reflection": "Refleksija udeleženca",
    "button.add_key": "Dodaj ključ",
    "header.appMotto": "DUKE",
    "table.qualifying": "Kvalifikacijska",
    "button.upload": "Naloži",
    "button.resend": "Ponovno pošlji",
    "label.filename": "Ime datoteke",
    "label.change_parental_consent": "Spremeni tiskano soglasje v elektronsko",
    "button.cancel": "Prekliči",
    "label.aply_to_all_langs": "Uveljavi pri vseh jezikovnih različicah",
    "route.customization": "Po meri",
    "errors.minimal_duration_is": "Najkrajši čas trajanje je 30 minut.",
    "label.email_help_participant_first_name": "Ime udeleženca.",
    "label.participant_status": "Status udeleženca",
    "award.bronze_level_short": "Bronasta",
    "label.phone_type": "Vrsta telefona",
    "global.night": "noč",
    "button.adventurous_journey_settings": "Nastavitve pustolovske odprave",
    "participant.leader_must_be_selected": "Mentor mora biti izbran.",
    "pageTitle.translationsManagement": "Upravljanje prevodov",
    "moduleTitle.user_added_preparation_and_training": "Dodatne priprave na odpravo",
    "table.approve": "Odobri",
    "label.role_in_organisation": "Vloga v organizaciji",
    "states.finished": "Zaključeno",
    "label.created": "Ustvarjeno",
    "button.back_to_home": "Nazaj domov",
    "label.options": "Možnosti",
    "contact.next_level_invitation": "Povabi na naslednjo stopnjo",
    "moduleTitle.activity_detail": "Podrobnosti o dejavnosti",
    "route.section_signoff": "Potrditev področja",
    "moduleTitle.assign_labels_bulk": "Dodeli izbrane oznake ",
    "button.contact_settings": "Nastavitve kontakta",
    "label.transation_id": "ID transakcije",
    "notifications.activity_has_been_updated": "Dejavnost je posodobljena.",
    "sidebar.awards": "Avtorizacija priznanj",
    "parentalConsent.images_consent": "Kot starš/skrbnik dajem soglasje, da lahko Nacionalni urad MEPI in povezane organizacije vse slike uporabljajo za promocijske namene.",
    "participant.would_you_like_to_delete": "Ali želite izbrisati ta račun?",
    "roles.user": "Uporabnik",
    "label.label": "Oznaka",
    "label.select_sheet": "Izberite preglednico na računalniku",
    "global.no_results": "Ni rezultatov",
    "moduleTitle.address_line_2": "Dodatna vrstica za naslov (neobvezno)",
    "states.awaiting_office_sign_off": "Potrditev nacionalnega urada",
    "moduleTitle.export": "Izvozi",
    "moduleTitle.address_line_1": "Ulica in hišna številka",
    "notifications.participant_has_been_assigned": "Udeleženec je bil dodan.",
    "roles.viewer": "Up. z osnov. pooblastili",
    "label.participants_total": "Skupaj udeležencev",
    "errors.auth_code_is_no_longer_valid": "Veljavnost avtorizacijske kode je potekla",
    "label.file_is_not_available": "Datoteka ni na voljo.",
    "button.select_template": "Izberi predlogo",
    "label.payment": "Plačilo",
    "award.silver_level_short": "Srebrna",
    "table.participant_id": "ID udeleženca",
    "text.hours_old": "Starost: {hours} ur",
    "moduleTitle.your_personal_information": "Osebni podatki",
    "aj.minimum_date_recommendation": "Najmanjši časovni obseg za poskusno pustolovsko odpravo je",
    "label.date_of_payment": "Datum plačila",
    "button.view": "Prikaži",
    "label.create_new_label": "Ustvari novo oznako",
    "title.confirmation": "Potrditev",
    "button.set_participants": "Nastavi udeležence",
    "roles.assessor": "Ocenjevalec",
    "moduleTitle.coordinator_settings": "Nastavitve koordinatorja",
    "label.parent_relationship": "Sorodstveno razmerje starša",
    "table.nao": "Nacionalni urad",
    "notifications.email_has_been_sent": "E-poštno sporočilo je bilo poslano.",
    "label.email_help_participant_full_name": "Ime in priimek udeleženca.",
    "sidebar.suboperating_authorities": "Lokalni uradi",
    "route.award": "Priznanje",
    "label.no_roles": "Ni vlog",
    "table.files": "Datoteke",
    "aj.minimum_date_requirements": "Kvalifikacijska odprava mora trajati vsaj ",
    "pageTitle.labels": "Oznake",
    "label.participant_is_semi_offline": "Udeleženec ima tiskan indeks",
    "moduleTitle.other_coordinators": "Drugi koordinatorji",
    "button.updateSelectedLanguage": "Posodobi izbrani jezik",
    "tasks.approve_award_registration": "Odobri registracijo",
    "participant.invite_participant_to_next_level": "Ali želite povabiti udeleženca na naslednjo stopnjo?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Priznanja",
    "warning.award_marked_as_paid": "Opozorilo! Udeleženec je plačal pristopnino za vsaj eno stopnjo programa. Pred potrditvijo izbrisa se posvetujte z Nacionalnim uradom MEPI.",
    "table.edit": "Preglej",
    "states.change_to_state_warning_missing_hours_to_complete": "OPOZORILO! Minimalno število ur ni doseženo. Res želite nadaljevati?",
    "label.dofe": "MEPI",
    "moduleTitle.after_assigning_a_role_to_yourself": "Ko sebi dodelite vlogo ali jo spremenite, se boste morali znova prijaviti.",
    "label.transaction_id": "Številka računa",
    "table.suboperating_authority": "Lokalni urad",
    "label.participant_survey": "Kot udeleženec Programa MEPI se strinjam s sodelovanjem v anketah Nacionalnega urada MEPI",
    "label.created_by": "Ustvaril/-a",
    "button.send_confirmation_email_again_question": "Ponovno pošlji potrditveno sporočilo",
    "label.email_help_award_leader_email": "E-naslov mentorja.",
    "label.name": "Ime",
    "tabs.gold_level": "Zlata stopnja",
    "pageTitle.award_documents": "Dokumenti o priznanju",
    "label.online_payments": "Spletna plačila",
    "label.child_protection_number": "Številka potrdila o nekaznovanosti",
    "participant.send_password_recovery_email": "Pošljem sporočilo za ponastavitev gesla?",
    "notifications.new_log_has_been_added": "Nov dnevniški vnos je bil dodan.",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Ime organizacije",
    "pageTitle.my_organization_templates": "Moja organizacija – predloge",
    "pageTitle.award_leaders": "Mentorji",
    "label.status": "Status",
    "label.street": "Ulica",
    "roles.if_staff_superuser": "Up. s polnimi pooblastili (IAF)",
    "table.licence_holder": "Zakoniti zastopnik",
    "label.created_at": "Ustvarjeno",
    "table.section": "Področje",
    "table.system_rights": "Sistemske pravice",
    "label.iac_type": "Vrsta IAC",
    "label.other": "Drugo",
    "moduleTitle.login": "Prijava",
    "label.no_data_to_show": "Ni podatkov za prikaz",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Če so udeleženci dodani pustolovski odpravi, stopnje odprave ni mogoče več spreminjati.",
    "tabs.waiting_payments": "Čakanje na plačilo",
    "global.supervisor": "Spremljevalec",
    "notifications.new_role_has_been_added": "Nova vloga je dodana.",
    "award.silver_level": "Srebrna stopnja",
    "heading.change_awards_mode": "Spremeni način beleženja Programa MEPI",
    "button.save_changes": "Shrani spremembe",
    "organisation.would_you_like_to_move_award_unit": "Kam bi radi premaknili to organizacijo?",
    "label.fields": "label.fields",
    "label.email_help_organization_name": "Ime izvajalske organizacije.",
    "pageTitle.mro_related_detail": "Regionalna pisarna IAF - podrobnosti",
    "table.started_at": "Začeto",
    "parentalConsent.i_consent_to_the_award_unit": "2. Strinjam se, da izvajalska organizacija in vsi drugi posamezniki, vključno s prostovoljci*, ki so udeleženi ali pomagajo pri organizaciji programa MEPI, ter najetimi vozniki, organizirajo in izpeljejo prevoz udeležencev z namenom sodelovanja v dejavnostih, povezanih s programom, kadar je to potrebno. Razumem, da me bo izvajalska organizacija vnaprej obvestila, kdaj in kje se bo tovrsten prevoz zgodil.",
    "logs.minutes": "min",
    "label.total_participants": "Vsi udeleženci",
    "moduleTitle.contact_info": "Kontaktni podatki",
    "table.payment_link": "Povezava na plačilo",
    "errors.please_contact_your_local_award_staff": "Prosimo, obrnite se na nacionalni urad."
}